import { isMl3App } from './DeviceOptions';
import Cookies from './Cookies';

let definedCoords = false;

// set definedCoords -> ?coords=20.1233,124.123321
// unset definedCoords -> ?uncoords=1
const checkHasDefinedCoords = () => {
  const setKey = 'coords';
  const unsetKey = 'uncoords';
  const url = new URL(window.location.href);

  if (url.searchParams.get(unsetKey)) {
    Cookies.remove(setKey);
    return;
  }

  let coords = url.searchParams.get(setKey);
  if (!coords) {
    coords = Cookies.get(setKey);
  }

  if (coords) {
    Cookies.set(setKey, coords, { expires: 10000 });

    const [latitude, longitude] = coords.split(',');
    definedCoords = {
      coords: {
        latitude: parseFloat(latitude),
        longitude: parseFloat(longitude)
      }
    };
  }
};

checkHasDefinedCoords();

export const getCurrentPosition = (options = {}) => {
  return new Promise((resolve, reject) => {
    if (definedCoords) {
      return resolve(definedCoords);
    }

    try {
      if (isMl3App) {
        if (window.Ml3AppObjs.NativeCurrentPos) {
          const latitude = window.Ml3AppObjs.NativeCurrentPos.lat();
          const longitude = window.Ml3AppObjs.NativeCurrentPos.lng();

          return resolve({
            coords: {
              latitude,
              longitude
            }
          });
        }

        window.Ml3AppObjs.NativeLocationCallback = () => {
          if (window.Ml3AppObjs.NativeCurrentPos) {
            const latitude = window.Ml3AppObjs.NativeCurrentPos.lat();
            const longitude = window.Ml3AppObjs.NativeCurrentPos.lng();

            return resolve({
              coords: {
                latitude,
                longitude
              }
            });
          }

          reject(new Error(window.resolveLang('位置情報取得に失敗しました')));
        };

        return;
      }

      window.navigator.geolocation.getCurrentPosition(
        resolve,
        () => {
          reject(
            new Error(
              window.resolveLang('現在地取得のため位置情報を許可してください')
            )
          );
        },
        options
      );
    } catch (e) {
      reject(new Error(window.resolveLang('現在地が取得できませんでした。')));
    }
  });
};

export const watchPosition = (successCallback, errorCallback) => {
  // // * if watchPosition is used, getCurrentPosition becomes laggy
  // // * so has to use setInterval
  // return window.navigator.geolocation.watchPosition(
  //   successCallback,
  //   errorCallback
  // );

  return setInterval(() => {
    getCurrentPosition()
      .then(successCallback)
      .catch(errorCallback);
  }, 3000);
};

export const clearWatch = id => clearInterval(id);
